import React from 'react';
import { Link } from 'react-router-dom';

export default {
  displaySize: 5,
  pageSize: 15,
  pipelineWaitTenMinMoreInfoMessage: <p>Once it has been created, please allow up to a few minutes for the opportunity to enter the  <Link to="/portal/pipeline">Pipeline</Link>.</p>
};
